function createDecoder() {
  if (typeof document !== "undefined") {
    const element = document.createElement("i");
    return function decode(text) {
      const html = `&${text};`;
      element.innerHTML = html;
      const result = element.textContent;
      if (result?.charCodeAt(result.length - 1) === 59 && text !== "semi" || result === html) {
        return false;
      }
      return result;
    };
  }
  return function decode(text) {
    const entities = {
      lt: "<",
      gt: ">",
      amp: "&",
      quot: '"',
      apos: "'"
    };
    return entities[text] || false;
  };
}
const decodeNamedCharacterReference = createDecoder();

export { decodeNamedCharacterReference };
//# sourceMappingURL=decodeCharacterReference.js.map
